import React from 'react';
import { useTranslation } from 'react-i18next';

const RadiologyPage = ({ onButtonClick, onBack, onOpenCT, onOpenXRay, onOpenMRI }) => {
  const { t } = useTranslation();
  
  // Массив услуг с именами файлов для иконок
  const radiologyServices = [
    { iconName: 'kt.png', name: t('radiologyPage.services.ct') },
    { iconName: 'mmg.png', name: t('radiologyPage.services.xray') },
    { iconName: 'rentgen.png', name: t('radiologyPage.services.mri') },
    { iconName: 'back.png', name: t('radiologyPage.services.back') }
  ];

  const handleServiceClick = (serviceName) => {
    if (serviceName === t('radiologyPage.services.back')) {
      onBack();
    } else if (serviceName === t('radiologyPage.services.ct')) {
      onOpenCT();
    } else if (serviceName === t('radiologyPage.services.xray')) {
      onOpenXRay();
    } else if (serviceName === t('radiologyPage.services.mri')) {
      onOpenMRI();
    } else {
      onButtonClick(serviceName);
    }
  };

  return (
    <>
      {/* Шапка раздела лучевой диагностики */}
      <header className="header">
        <div className="clinic-logo">
          {/* Логотип раздела также можно заменить на изображение, если нужно */}
          <div className="logo-icon">📡</div>
          <h1>{t('radiologyPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('radiologyPage.subtitle')}</p>
        </div>
      </header>

      {/* Основной контент */}
      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('radiologyPage.welcome')}</h2>
          <p className="subtitle">{t('radiologyPage.description')}</p>
        </div>

        {/* Сетка кнопок услуг */}
        <div className="buttons-grid">
          {radiologyServices.map((service, index) => (
            <button 
              key={index}
              className={`service-btn ${service.name === t('radiologyPage.services.back') ? 'back-btn' : ''}`}
              onClick={() => handleServiceClick(service.name)}
            >
              {/* Заменяем эмодзи на тег <img> */}
              <span className="btn-icon">
                <img 
                  src={`${process.env.PUBLIC_URL}/icons/${service.iconName}`}
                  alt={service.name}
                />
              </span>
              <span className="btn-text">{service.name}</span>
            </button>
          ))}
        </div>
      </main>

      {/* Футер */}
      <footer className="footer">
        <p>{t('radiologyPage.footer.main')}</p>
        <p className="footer-info">{t('radiologyPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default RadiologyPage;